<template>
  <!-- 订单详情 -->
  <div class="orderDetails" v-if="dialogVisible">
    <el-dialog
      width="92%"
      custom-class="order-dialog"
      :visible.sync="dialogVisible"
      @close="handleDialogClose"
    >
      <div slot="title" class="order-dialog__title">
        <div class="order-dialog__title-main">
          <span class="order-dialog__sn">{{ detailsData.orderSn || "商城订单详情" }}</span>
          <el-tag
            v-if="hasOrderStatus(detailsData.status)"
            size="small"
            effect="plain"
            class="order-dialog__status-tag"
          >
            {{ orderStatus(detailsData.status) }}
          </el-tag>
          <el-tag v-if="detailsData.channelName" size="small" type="info" effect="plain">
            {{ detailsData.channelName }}
          </el-tag>
          <el-tag
            v-if="detailsData.sendType"
            size="small"
            type="success"
            effect="plain"
          >第三方发货</el-tag>
          <el-tag v-else size="small" effect="plain">内部发货</el-tag>
        </div>
      </div>

      <div class="order-detail-body">
        <div class="order-summary">
          <div class="order-summary__item">
            <span class="order-summary__label">实付金额</span>
            <span class="order-summary__value order-summary__value--primary">
              ¥{{ detailsData.payAmount != null ? detailsData.payAmount : "0.00" }}
            </span>
          </div>
          <div class="order-summary__item">
            <span class="order-summary__label">运费</span>
            <span class="order-summary__value">
              {{ detailsData.postage != null ? detailsData.postage : "-" }}
            </span>
          </div>
          <div class="order-summary__item">
            <span class="order-summary__label">总数量 / 实际数量</span>
            <span class="order-summary__value">
              {{ shipmentQuantity.total }} / {{ shipmentQuantity.actual }}
            </span>
          </div>
          <div class="order-summary__item">
            <span class="order-summary__label">用户号码</span>
            <span class="order-summary__value">{{ detailsData.phone || "-" }}</span>
          </div>
        </div>

        <div class="detail-cards">
          <section class="detail-section">
            <div class="detail-section__head">
              <i class="el-icon-document detail-section__icon"></i>
              <h3 class="detail-section__title">订单信息</h3>
            </div>
            <div class="detail-section__body">
              <el-descriptions :column="2" size="small" border>
                <el-descriptions-item label="支付方式">
                  <el-tag type="success" size="mini" v-if="detailsData.payType == '1'">微信</el-tag>
                  <el-tag type="danger" size="mini" v-else-if="detailsData.payType == '0'">未支付</el-tag>
                  <span v-else>-</span>
                </el-descriptions-item>
                <el-descriptions-item label="下单时间">{{ detailsData.payTime || "-" }}</el-descriptions-item>
                <el-descriptions-item label="支付单号">{{ detailsData.paySn || "-" }}</el-descriptions-item>
                <el-descriptions-item label="发货时间">{{ detailsData.senderTime || "-" }}</el-descriptions-item>
                <el-descriptions-item label="物流单号">
                  <el-link
                    v-if="detailsData.deliverySn"
                    :underline="false"
                    type="primary"
                    @click="expressDetail(detailsData.deliverySn)"
                  >{{ detailsData.deliverySn }}</el-link>
                  <span v-else>-</span>
                </el-descriptions-item>
                <el-descriptions-item label="下单来源">
                  <el-tag type="success" size="mini" v-if="detailsData.type == 0">线上</el-tag>
                  <el-tag type="warning" size="mini" v-else-if="detailsData.type == 1">门店</el-tag>
                  <span v-else>-</span>
                </el-descriptions-item>
                <el-descriptions-item label="订单备注" :span="2">
                  <el-tooltip
                    v-if="detailsData.note"
                    :content="detailsData.note"
                    placement="top"
                    effect="dark"
                    :disabled="isContentShort(detailsData.note)"
                  >
                    <div class="ellipsis">{{ detailsData.note }}</div>
                  </el-tooltip>
                  <span v-else>-</span>
                </el-descriptions-item>
              </el-descriptions>
            </div>
          </section>

          <section class="detail-section">
            <div class="detail-section__head">
              <i class="el-icon-money detail-section__icon detail-section__icon--money"></i>
              <h3 class="detail-section__title">金额明细</h3>
            </div>
            <div class="detail-section__body">
              <el-descriptions :column="2" size="small" border>
                <el-descriptions-item label="微信支付">
                  {{ detailsData.wxAmount != null ? detailsData.wxAmount : 0 }}
                </el-descriptions-item>
                <el-descriptions-item label="余额支付">
                  {{ detailsData.balancelAmount != null ? detailsData.balancelAmount : 0 }}
                </el-descriptions-item>
                <el-descriptions-item label="实付金额">{{ detailsData.payAmount || 0 }}</el-descriptions-item>
                <el-descriptions-item label="运费">
                  {{ detailsData.postage != null ? detailsData.postage : "-" }}
                </el-descriptions-item>
              </el-descriptions>
            </div>
          </section>

          <section class="detail-section detail-section--full">
            <div class="detail-section__head">
              <i class="el-icon-location-outline detail-section__icon detail-section__icon--address"></i>
              <h3 class="detail-section__title">收货信息</h3>
            </div>
            <div class="detail-section__body">
              <div class="address-cards address-cards--single">
                <section class="address-card">
                  <div class="address-card__head">
                    <i class="el-icon-user"></i>
                    收货人信息
                  </div>
                  <div class="address-card__body">
                    <p><span class="address-card__label">姓名</span>{{ detailsData.senderName || "-" }}</p>
                    <p><span class="address-card__label">电话</span>{{ detailsData.senderPhone || "-" }}</p>
                    <p class="address-card__addr">{{ formatSenderAddress() }}</p>
                  </div>
                </section>
              </div>
            </div>
          </section>
        </div>

        <div class="detail-btn">
          <el-button
            v-if="detailsData.status <= 1"
            size="small"
            :loading="actionLoading"
            :disabled="actionLoading"
            @click="handleRefundSmall(detailsData)"
            type="danger"
          >
            <el-tooltip
              class="item"
              effect="dark"
              content="全选为整单取消/反之为取消选中的商品"
              placement="top"
            >
              <span>取消订单</span>
            </el-tooltip>
          </el-button>
          <el-button
            v-if="detailsData.status <= 1 && !hasShippedSubOrders"
            size="small"
            :loading="actionLoading"
            :disabled="actionLoading"
            @click="handleRefundSmallAll(detailsData)"
            type="danger"
          >整单取消</el-button>
          <el-button
            v-if="detailsData.status < 5"
            size="small"
            :loading="actionLoading"
            :disabled="actionLoading"
            @click="handleServeSmall"
            type="warning"
          >提交完成</el-button>
          <el-button type="primary" size="small" @click="handleOrderNote">修改备注</el-button>
          <el-button
            v-if="detailsData.status <= 1"
            type="primary"
            size="small"
            @click="dialogVisibleAddr = true"
          >修改地址</el-button>
        </div>

        <el-tabs class="order-tabs" @tab-click="handleTabClick" v-model="activeNameTab">
          <el-tab-pane label="发货信息" name="1">
            <div class="tab-panel">
            <el-table
              ref="shipmentTable"
              v-loading="shipmentLoading"
              :data="shipmentData"
              style="width: 100%"
              tooltip-effect="dark"
              @selection-change="handleSelectionChange"
              :header-cell-style="{ 'text-align': 'center' }"
              :cell-style="{ 'text-align': 'center' }"
            >
              <el-table-column
                type="selection"
                width="55"
                :selectable="isRowSelectable"
              ></el-table-column>
              <el-table-column label="订单编号" prop="orderSn" width="160">
                <template slot-scope="scope">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <el-link
                      type="primary"
                      @click="handleEditInternal(scope.row)"
                    >
                      <p>
                        {{ scope.row.orderSn }}
                      </p>
                    </el-link>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="paySn"
                label="支付订单号"
              ></el-table-column>
              <el-table-column
                prop="productName"
                label="商品名称"
                width="150"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column prop="productPic" label="商品图片" width="120">
                <template v-slot:default="scope">
                  <el-image
                    style="width: 50px; height: 50px"
                    :src="scope.row.pic"
                  />
                </template>
              </el-table-column>
              <el-table-column prop="deliverySn" label="快递单号" width="180">
                <template v-slot:default="scope">
                  <el-link
                    :underline="false"
                    type="primary"
                    v-if="scope.row.deliverySn"
                    v-for="(item, index) in scope.row.deliverySn
                      ? scope.row.deliverySn.split(',')
                      : []"
                    :key="index"
                    @click="expressDetail(item)"
                  >
                    {{ item }}
                  </el-link>
                </template>
              </el-table-column>
              <el-table-column prop="deliveryCompany" label="快递公司名称">
                <template v-slot:default="scope">
                  <p>
                    {{ getCompanyName(scope.row.deliveryCompany) }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column
                prop="supplierId"
                label="供应商"
                :formatter="formatSupplierName"
                width="120"
              ></el-table-column>
              <el-table-column
                prop="quantity"
                label="数量"
                width="120"
              ></el-table-column>
              <el-table-column prop="status" label="订单状态">
                <template slot-scope="scope">
                  <el-tag type="danger" v-if="scope.row.status == '1'"
                    >已取消</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column prop="expressStatus" label="物流状态">
                <template slot-scope="scope">
                  <div>{{ orderItemStatus(scope.row.expressStatus) }}</div>
                </template>
              </el-table-column>
            </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="商品信息" name="0">
            <div class="tab-panel">
            <el-table
              :data="productTable"
              style="width: 100%"
              tooltip-effect="dark"
              :header-cell-style="{ 'text-align': 'center' }"
              :cell-style="{ 'text-align': 'center' }"
            >
              <el-table-column type="index" width="50"></el-table-column>
              <el-table-column
                prop="productId"
                label="商品ID"
                width="100"
              ></el-table-column>
              <el-table-column
                prop="productCategory"
                label="商品分类"
              ></el-table-column>
              <el-table-column
                prop="productName"
                label="商品名称"
              ></el-table-column>
              <el-table-column label="商品图片">
                <template slot-scope="scope">
                  <img width="80px" height="60px" :src="scope.row.productPic" />
                </template>
              </el-table-column>
              <el-table-column
                prop="originalAmount"
                label="市场价格"
              ></el-table-column>
              <el-table-column
                prop="memberAmount"
                label="专属价格"
              ></el-table-column>
              <el-table-column
                prop="payAmount"
                label="实付价格"
              ></el-table-column>
              <el-table-column
                prop="quantity"
                label="数量"
                width="100"
              ></el-table-column>
            </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="工单信息" name="2">
            <div class="tab-panel">
            <el-table
              :data="workTableData"
              style="width: 100%"
              tooltip-effect="dark"
              :header-cell-style="{ 'text-align': 'center' }"
              :cell-style="{ 'text-align': 'center' }"
            >
              <el-table-column
                type="index"
                width="50"
                label="#"
              ></el-table-column>
              <el-table-column
                prop="orderSn"
                label="订单编号"
                width="160"
              ></el-table-column>
              <!-- <el-table-column prop="washingCode" label="水洗码" width="150"></el-table-column> -->
              <el-table-column label="工单类型">
                <template slot-scope="scope">
                  <div>{{ workOrderStatus(scope.row.workType) }}</div>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column> -->
              <el-table-column
                prop="promoterMan"
                label="发起人员"
                width="120"
              ></el-table-column>
              <el-table-column label="优先级">
                <template slot-scope="scope">
                  <el-tag type="primary" v-if="scope.row.priority == '1'"
                    >普通</el-tag
                  >
                  <el-tag type="danger" v-else-if="scope.row.priority == '2'"
                    >紧急</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column label="申请状态">
                <template slot-scope="scope">
                  <el-tag type="primary" v-if="scope.row.status == '0'"
                    >待处理</el-tag
                  >
                  <el-tag type="success" v-else-if="scope.row.status == '2'"
                    >已完成</el-tag
                  >
                  <el-tag type="danger" v-else-if="scope.row.status == '3'"
                    >已拒绝</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="handleMan"
                label="处理人员"
                width="120"
              ></el-table-column>
              <el-table-column
                prop="modifyTime"
                label="修改时间"
                width="180"
              ></el-table-column>
              <el-table-column
                prop="handleNote"
                label="处理备注"
                width="150"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column label="操作" width="100" fixed="right">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="handleEdit(scope.row)"
                    type="primary"
                    >编辑</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
    <!-- 物流状态弹框 -->
    <el-drawer
      title="物流轨迹"
      :visible.sync="drawer"
      :before-close="handleClose"
    >
      <el-timeline :reverse="true">
        <el-timeline-item
          v-for="(activity, index) in preDetail.Traces"
          :key="index"
          :timestamp="activity.AcceptTime"
          >{{ activity.AcceptStation }}</el-timeline-item
        >
      </el-timeline>
    </el-drawer>
    <!-- 修改备注弹框 -->
    <el-dialog
      custom-class="custom-begin-dialog"
      title="修改订单备注"
      :visible.sync="dialogVisibleNote"
      width="30%"
      center
    >
      <el-form
        :model="detailsData"
        ref="orderNoteRef"
        label-width="80px"
        size="small"
      >
        <el-form-item label="订单备注:" prop="note">
          <el-input type="textarea" :rows="5" v-model="orderNote"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleNote = false" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="handleDialogNote" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 工单 -->
    <WorkDetail
      :visible.sync="workDialogVisible"
      :my-work="workObj"
    ></WorkDetail>
    <!-- 修改收货地址弹框子组件 -->
    <SmallAddress
      :visible.sync="dialogVisibleAddr"
      :my-order="detailsData"
      @refreshList="refreshParentOrder"
    ></SmallAddress>
    <!-- 创建工单弹框 -->
    <CreateWork
      :key="workTimer"
      :my-object="detailsData"
      :isWork="3"
      :smallText="smallText"
      :visible.sync="dialogVisibleSmall"
      @refreshWork="refreshParent"
    ></CreateWork>
    <InternalDetails
      :visible.sync="dialogVisibleInternal"
      :my-order="orderObj"
      @refreshOrder="refreshParentInternal"
    ></InternalDetails>
  </div>
</template>

<script>
// 订单号获取工单、支付订单号查询商品信息、订单修改、物流状态
import {
  orderWorkBySmall,
  getOrderProductSmall,
  updateOrderSmall,
} from "@/api/mall.js";

const SHIPMENT_PAGE_SIZE = 100;
// 批量修改子订单状态、 供应商发货子订单不分页、物流轨迹
import {
  updateBatchOrderItem,
  getOrderItemSupAll,
  getThirdExpress,
} from "@/api/supplier.js";

// 处理工单弹出框
import WorkDetail from "@/components/order/WorkDetail.vue";
// 创建工单弹出框
import CreateWork from "@/components/work/CreateWork.vue";
// 修改收货地址子组件弹框
import SmallAddress from "@/components/address/SmallAddress.vue";
// 子订单发货详情弹框
import InternalDetails from "@/components/small/InternalDetails.vue";
// 供应商公司列表
import { getSupplierCompany } from "@/api/supplier.js";
export default {
  name: "OrderDetails",
  components: {
    WorkDetail,
    SmallAddress,
    CreateWork,
    InternalDetails,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 传整个订单对象
    myOrder: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      // 订单
      detailsData: this.myOrder,
      activeNameTab: "1", //默认显示发货信息
      // 商城商品信息
      productTable: [],
      // 工单信息
      workTableData: [],
      shipmentData: [], //供应商发货信息
      formatSupplier: [], //供应商列表
      // 创建供应商公司映射表，提高查找效率
      supplierMap: {},
      workObj: {}, //工单处理对象
      smallText: "",
      workDialogVisible: false,
      // 控制物流状态右侧弹框
      drawer: false,
      // 物流轨迹
      preDetail: [],
      // 修改备注弹框
      dialogVisibleNote: false,
      dialogVisibleAddr: false, //修改收货地址弹框
      orderNote: "", //订单备注
      dialogVisibleSmall: false,
      orderObj: {}, //子订单发货对象
      dialogVisibleInternal: false,
      multipleSelection: [], //多选
      workTimer: "", //创建工单子组件只执行一次dom问题
      actionLoading: false,
      shipmentLoading: false,
    };
  },
  computed: {
    /** 是否存在已发货（有快递单号）的子单 */
    hasShippedSubOrders() {
      return (this.shipmentData || []).some((item) => !!item.deliverySn);
    },
    /** 可勾选取消的未发货子单 */
    cancellableSubOrders() {
      return (this.shipmentData || []).filter(
        (item) => !item.deliverySn && !Number(item.status),
      );
    },
    /** 发货信息 quantity：总数量 / 除去已取消的实际数量 */
    shipmentQuantity() {
      const list = this.shipmentData || [];
      let total = 0;
      let actual = 0;
      list.forEach((item) => {
        const qty = Number(item.quantity);
        const n = Number.isFinite(qty) ? qty : 0;
        total += n;
        // 子单 status=1 为已取消
        if (Number(item.status) !== 1) {
          actual += n;
        }
      });
      return { total, actual };
    },
  },
  watch: {
    visible(newValue) {
      this.dialogVisible = newValue;
      if (!newValue) {
        this.resetDetailSession();
        this.$emit("refreshOrder", true);
      } else {
        this.$nextTick(() => {
          this.loadOrderDetailData();
        });
      }
      this.detailDirty = false;
      this.detailsData = { ...this.myOrder };
      const seq = ++this.openSeq;
      this.$nextTick(() => {
        if (seq !== this.openSeq) {
          return;
        }
        this.loadDetailData();
      });
    },
  },
  created() {},
  mounted() {},
  methods: {
    hasOrderStatus(status) {
      return status !== null && status !== undefined && status !== "";
    },
    markDetailDirty() {
      this.detailDirty = true;
    },
    loadDetailData() {
      this.supplierListAll();
      this.handleTabClick();
      this.getShipmentList(this.detailsData.paySn);
      this.getOrderWork(this.detailsData.orderSn);
    },
    // 格式化供应商公司列
    formatSupplierName(row, column) {
      // 从映射表中查找对应的物流公司名称
      return this.supplierMap[row.supplierId] || row.supplierId;
    },
    // 创建物流公司映射表（label -> value）
    createSupplierMap(supplier) {
      return supplier.reduce((map, company) => {
        map[company.id] = company.supplierName;
        return map;
      }, {});
    },
    async supplierListAll() {
      if (this.formatSupplier.length) {
        return;
      }
      const { data: res } = await getSupplierCompany();
      // console.log('yh', res)
      if (res.code === 200) {
        this.formatSupplier = res.data.list;
        this.supplierMap = this.createSupplierMap(this.formatSupplier);
      }
    },
    handleTabClick() {
      if (this.activeNameTab == "0") {
        // 商城小程序根据订单号查商品
        this.getOrderProduct(this.detailsData);
      }
    },
    handleDialogClose() {
      this.resetDetailSession();
      this.$emit("update:visible", false);
    },
    resetDetailSession() {
      this.shipmentData = [];
      this.multipleSelection = [];
      this.productTable = [];
      this.workTableData = [];
      this.activeNameTab = "1";
      this.clearTableSelection();
    },
    clearTableSelection() {
      this.multipleSelection = [];
      this.$nextTick(() => {
        if (this.$refs.shipmentTable) {
          this.$refs.shipmentTable.clearSelection();
        }
      });
    },
    parseShipmentResponse(raw) {
      if (Array.isArray(raw)) {
        return { list: raw, total: raw.length };
      }
      if (raw && Array.isArray(raw.list)) {
        return {
          list: raw.list,
          total: raw.total != null ? Number(raw.total) : raw.list.length,
        };
      }
      return { list: [], total: 0 };
    },
    async loadOrderDetailData() {
      if (!this.detailsData || !this.detailsData.paySn) {
        return;
      }
      await Promise.all([
        this.supplierListAll(),
        this.getShipmentList(this.detailsData.paySn),
        this.getOrderWork(this.detailsData.orderSn),
      ]);
      this.handleTabClick();
    },
    async getShipmentList(paySn) {
      if (!paySn) {
        this.shipmentData = [];
        return;
      }
      this.shipmentLoading = true;
      try {
        const all = [];
        let pageNum = 1;
        let total = 0;
        while (pageNum <= 50) {
          const { data: res } = await getOrderItemSupAll({
            paySn,
            pageNum,
            pageSize: SHIPMENT_PAGE_SIZE,
          });
          if (res.code !== 200) {
            break;
          }
          const page = this.parseShipmentResponse(res.data);
          if (!page.list.length) {
            break;
          }
          all.push(...page.list);
          total = page.total || all.length;
          if (all.length >= total || page.list.length < SHIPMENT_PAGE_SIZE) {
            break;
          }
          pageNum += 1;
        }
        this.shipmentData = all;
      } finally {
        this.shipmentLoading = false;
      }
    },
    // 工单
    async getOrderWork(orderSn) {
      this.workTableData = [];
      const { data: res } = await orderWorkBySmall(orderSn);
      if (res.code === 200) {
        this.workTableData = res.data;
      }
      // return this.$message.error("获取工单信息失败！");
    },
    // 商品
    async getOrderProduct(data) {
      this.productTable = [];
      const { data: res } = await getOrderProductSmall(data.paySn);
      if (res.code === 200) {
        this.productTable = res.data;
      }
      console.log("dataid", data);
    },
    // 通过订单号获取寄出物流轨迹
    async expressDetail(mailNo) {
      this.drawer = true;
      this.preDetail = [];
      const { data: res } = await getThirdExpress(mailNo);
      if (res.code === 200 && res.data != null) {
        let arr = res.data.length;
        if (arr != 0) {
          this.preDetail = res.data;
        } else {
          this.preDetail = [];
        }
      } else {
        this.$message.error(`${res.message}`);
      }
    },
    // 关闭物流状态弹框
    handleClose(done) {
      this.drawer = false;
    },
    // 提前完结修改状态为已完成-5
    handleServeSmall() {
      let data = JSON.parse(JSON.stringify(this.detailsData));
      data.status = 5;
      this.$confirm("请确定是否完成此订单服务操作!", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.updateSmallOrder(data, 2);
          // updateOrderSmall(data).then(res => {
          //   if (res.data.code === 200) {
          //     this.detailsData = data;
          //     this.$message.success("提交完成服务成功！");
          //   }
          // });
        })
        .catch(() => {});
    },
    refreshParentInternal(e) {
      console.log("关闭商城订单详情", e);
      // 重新获取子订单
      this.getShipmentList(this.detailsData.paySn);
    },
    handleEditInternal(row) {
      this.dialogVisibleInternal = true;
      this.orderObj = row;
    },
    refreshParent(val) {
      this.dialogVisibleInternal = false;
      console.log("取消订单创建工单成功", val);
    },
    // 整单取消
    handleRefundSmallAll(row) {
      if (this.hasShippedSubOrders) {
        return this.$message.error("存在已发货子单，不能使用整单取消");
      }
      // 整单取消且要修改大订单状态及子订单状态
      let data = JSON.parse(JSON.stringify(row));
      data.status = 6;
      this.$confirm("整单取消只修改订单状态为已取消,退款请创建工单！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.smallText = "商城整单取消！";
          this.updateSmallOrder(data, 0);
          // updateOrderOffline(data).then(res => {
          //   if (res.data.code === 200) {
          //     this.detailsData = data;
          //     this.dialogVisibleSmall = true;
          //     this.$message.success("订单取消成功!");
          //   }
          // });
        })
        .catch(() => {});
    },
    // 取消订单、修改状态为已取消-6；进行退款操作以及新增记录
    handleRefundSmall(row) {
      if (!this.multipleSelection.length) {
        return this.$message.error("请选择需要取消的商品！");
      }
      if (
        !this.hasShippedSubOrders &&
        this.multipleSelection.length > 0 &&
        this.multipleSelection.length === this.shipmentData.length
      ) {
        // 整单取消且要修改大订单状态及子订单状态
        let data = JSON.parse(JSON.stringify(row));
        data.status = 6;
        this.$confirm(
          "取消订单只修改订单状态为已取消,退款请创建工单！",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          },
        )
          .then(() => {
            this.smallText = "商城整单取消！";
            this.updateSmallOrder(data, 0);
            // updateOrderOffline(data).then(res => {
            //   if (res.data.code === 200) {
            //     this.detailsData = data;
            //     this.dialogVisibleSmall = true;
            //     this.$message.success("订单取消成功!");
            //   }
            // });
          })
          .catch(() => {});
      } else {
        this.smallText = "商城部分商品取消！";
        if (this.actionLoading) {
          return;
        }
        this.actionLoading = true;
        this.updateSmallItem(this.multipleSelection, true).finally(() => {
          this.actionLoading = false;
        });
      }
    },
    /** 批量更新子单：传完整对象，仅 patch 指定字段 */
    batchUpdateSubItems(items, patch, options = {}) {
      const {
        isAll = false,
        emptyMsg = "暂无子订单",
        successMsg = "",
        clearSelection = true,
      } = options;
      const list = Array.isArray(items) ? items : [];
      if (!list.length) {
        if (emptyMsg) {
          this.$message.warning(emptyMsg);
        }
        return Promise.resolve(false);
      }
      const payload = list.map((item) => {
        const copy = JSON.parse(JSON.stringify(item));
        patch(copy);
        return copy;
      });
      return updateBatchOrderItem(payload)
        .then((res) => {
          if (res.data.code === 200) {
            if (successMsg) {
              this.$message.success(successMsg);
            }
            if (isAll) {
              this.dialogVisibleSmall = true;
            }
            if (clearSelection) {
              this.clearTableSelection();
            }
            this.getShipmentList(this.detailsData.paySn);
            return true;
          }
          this.$message.error(res.data.message || "子订单批量更新失败");
          return false;
        })
        .catch((err) => {
          console.error(err);
          this.$message.error(err.message || "子订单批量更新失败");
          return false;
        });
    },
    // 批量修改子订单为已取消（status=1）
    updateSmallItem(data, isAll) {
      return this.batchUpdateSubItems(
        data,
        (item) => {
          item.status = 1;
        },
        {
          isAll,
          emptyMsg: "暂无子订单，无法取消",
          successMsg: isAll ? "选中的商品取消成功！" : "",
        },
      );
    },
    // 大订单完成时，未取消的子单物流状态改为已完成（expressStatus=5）
    updateSubItemsExpressComplete(data) {
      const activeItems = (data || []).filter(
        (item) => Number(item.status) !== 1,
      );
      if (!activeItems.length) {
        return Promise.resolve(true);
      }
      return this.batchUpdateSubItems(
        activeItems,
        (item) => {
          item.expressStatus = 5;
        },
        { emptyMsg: "", clearSelection: false },
      );
    },
    // 修改备注按钮
    handleOrderNote() {
      this.orderNote = this.detailsData.note;
      this.dialogVisibleNote = true;
    },
    // 修改订单备注弹窗确认按钮
    handleDialogNote() {
      let data = JSON.parse(JSON.stringify(this.detailsData));
      data.note = this.orderNote;
      this.getUpdateOrder(data);
      this.dialogVisibleNote = false;
      console.log("note", data);
    },
    // 修改订单备注方法
    getUpdateOrder(data) {
      this.updateSmallOrder(data, 1);
      // updateOrderSmall(data).then(res => {
      //   if (res.data.code === 200) {
      //     this.detailsData = res.data.data;
      //     this.$message.success("订单备注修改成功！");
      //   }
      // });
    },
    // 修改订单
    async updateSmallOrder(data, isType) {
      if (this.actionLoading) {
        return;
      }
      this.actionLoading = true;
      try {
        const { data: res } = await updateOrderSmall(data);
        if (res.code !== 200) {
          this.$message.error(res.message || "订单更新失败");
          return;
        }
        this.detailsData = data;
        await this.getShipmentList(this.detailsData.paySn);
        if (isType == 1) {
          this.$message.success("订单备注修改成功！");
          return;
        }
        if (isType == 2) {
          const ok = await this.updateSubItemsExpressComplete(this.shipmentData);
          if (ok) {
            this.$message.success("提交完成服务成功！");
          } else {
            this.$message.warning(
              "大订单已完成，但部分子单物流状态更新失败，请刷新后重试",
            );
          }
          return;
        }
        if (isType == 0) {
          const ok = await this.updateSmallItem(this.shipmentData, false);
          if (ok) {
            this.dialogVisibleSmall = true;
            this.$message.success("订单取消成功");
          } else {
            this.$message.warning(
              "大订单已取消，但部分子单状态更新失败，请刷新后重试",
            );
          }
        }
      } catch (err) {
        console.error(err);
        this.$message.error(err.message || "订单更新失败");
      } finally {
        this.actionLoading = false;
      }
    },
    // 工单编辑操作
    handleEdit(row) {
      this.workDialogVisible = true;
      this.workObj = row;
    },
    formatSenderAddress() {
      const d = this.detailsData;
      const parts = [
        d.senderProvince,
        d.senderCity,
        d.senderRegion,
        d.senderDetailAddr,
      ].filter(Boolean);
      return parts.length ? parts.join("") : "-";
    },
    isContentShort(str) {
      return str <= 20;
    },
    // 寄回地址子组件传过来的方法刷新数据
    refreshParentOrder(data) {
      this.dialogVisibleAddr = false;
      this.detailsData = data;
      this.markDetailDirty();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log("val", val);
    },
    // 判断行是否可选(关键字段)
    isRowSelectable(row) {
      if (row.deliverySn) {
        return false;
      }
      return !Number(row.status);
    },
    // 订单状态
    orderStatus(v) {
      //状态:0->已付款；1->待发货；2->揽件；3->在途；4->配送中；5->完成；6->取消；7->客户取消寄件；8->已拒单
      switch (Number(v)) {
        case 0:
          return "已付款";
        case 1:
          return "待发货";
        case 2:
          return "已揽件";
        case 3:
          return "在途";
        case 4:
          return "配送中";
        case 5:
          return "已完成";
        case 6:
          return "已取消";
        case 7:
          return "客户取消寄件";
        case 8:
          return "已拒单";
        default:
          return "";
      }
    },
    // 子订单物流状态
    orderItemStatus(v) {
      //订单状态：1->待发货；2->揽件；3->在途；4->配送中；5->完成；
      switch (v) {
        case 1:
          return "待发货";
        case 2:
          return "已揽件";
        case 3:
          return "在途";
        case 5:
          return "已完成";
        default:
          return "";
      }
    },
    // 取消
    // toNext() {
    //   this.dialogVisible = false;
    // },
    // 工单类型
    workOrderStatus(v) {
      //类型:1->订单异常；2->售后；3->漏补发；4->催单；5->投诉；6->个人业务；7->疑似丢件；8->退款
      switch (v) {
        case 1:
          return "订单异常";
        case 2:
          return "售后";
        case 3:
          return "漏补发";
        case 4:
          return "催单";
        case 5:
          return "投诉";
        case 6:
          return "个人业务";
        case 7:
          return "疑似丢件";
        case 8:
          return "退款";
        case 9:
          return "数量不符";
        case 10:
          return "补款";
        default:
          return "";
      }
    },
    // 使用switch语句映射物流公司代码到中文名称
    getCompanyName(code) {
      switch (code) {
        case "ZTO":
          return "中通快递";
        case "STO":
          return "申通快递";
        case "YTO":
          return "圆通快递";
        case "YD":
          return "韵达快递";
        case "YZPY":
          return "邮政快递包裹";
        case "EMS":
          return "EMS";
        case "SF":
          return "顺丰速运";
        case "JD":
          return "京东快递";
        case "JDKY":
          return "京东快运";
        case "UC":
          return "优速快递";
        case "DBL":
          return "德邦快递";
        case "JTSD":
          return "极兔速递";
        case "CNSD":
          return "菜鸟速递";
        case "CNCY":
          return "菜鸟橙运";
        case "DNWL":
          return "丹鸟物流";
        default:
          return code; // 未知代码返回原码
      }
    },
  },
};
</script>

<style scoped lang="less">
.orderDetails {
  /deep/ .order-dialog {
    margin-top: 4vh !important;
    border-radius: 10px;
    overflow: hidden;

    .el-dialog__header {
      padding: 16px 24px 12px;
      border-bottom: 1px solid #ebeef5;
      background: linear-gradient(180deg, #fafbfc 0%, #fff 100%);
    }

    .el-dialog__body {
      padding: 0;
      max-height: calc(92vh - 60px);
      overflow-y: auto;
      background: #f5f7fa;
    }
  }

  /deep/ .custom-begin-dialog {
    height: 300px !important;
    margin-top: 200px !important;

    .el-dialog__body {
      padding: 10px 25px 0;

      .el-input__inner {
        width: 230px;
      }
    }
  }
}

.order-dialog__title-main {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.order-dialog__sn {
  font-size: 17px;
  font-weight: 600;
  color: #303133;
}

.order-detail-body {
  padding: 16px 20px 20px;
}

.order-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
  padding: 14px 18px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);

  &__item {
    flex: 1;
    min-width: 120px;
    text-align: center;
    padding: 4px 8px;

    &:not(:last-child) {
      border-right: 1px solid #f0f2f5;
    }
  }

  &__label {
    display: block;
    font-size: 12px;
    color: #909399;
    margin-bottom: 4px;
  }

  &__value {
    font-size: 16px;
    font-weight: 600;
    color: #303133;

    &--primary {
      color: #409eff;
      font-size: 18px;
    }

    &--name {
      font-size: 14px;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 180px;
      margin: 0 auto;
    }
  }
}

.detail-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-bottom: 16px;
}

.detail-section {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  overflow: hidden;

  &--full {
    grid-column: 1 / -1;
  }

  &__head {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    background: #fafbfc;
    border-bottom: 1px solid #f0f2f5;
  }

  &__icon {
    font-size: 16px;
    color: #409eff;

    &--money {
      color: #e6a23c;
    }

    &--address {
      color: #67c23a;
    }
  }

  &__title {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
  }

  &__body {
    padding: 12px 14px;
  }
}

.address-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;

  &--single {
    grid-template-columns: 1fr;
    max-width: 480px;
  }
}

.address-card {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;

  &__head {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 14px;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    background: #ecf5ff;
  }

  &__body {
    padding: 12px 14px;
    font-size: 13px;
    color: #606266;
    line-height: 1.8;

    p {
      margin: 0 0 4px;
    }
  }

  &__label {
    display: inline-block;
    width: 56px;
    color: #909399;
  }

  &__addr {
    margin-top: 6px !important;
    padding-top: 8px;
    border-top: 1px dashed #ebeef5;
    line-height: 1.6 !important;
  }
}

.detail-btn {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
  padding: 12px 14px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
}

.order-tabs {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  padding: 0 12px 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);

  /deep/ .el-tabs__header {
    margin-bottom: 0;
  }

  /deep/ .el-tabs__item {
    font-weight: 500;
    height: 44px;
    line-height: 44px;
  }

  /deep/ .el-tabs__item.is-active {
    font-weight: 600;
    color: #409eff;
  }
}

.tab-panel {
  padding-top: 12px;
}

/deep/ .el-image-viewer__wrapper {
  z-index: 9999 !important;
}

/deep/ .el-table__fixed-right::before {
  content: none;
}

/deep/ .el-drawer__body {
  padding-left: 10px;
  padding-top: 10px;
}

.ellipsis {
  max-width: 280px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

@media (max-width: 992px) {
  .detail-cards,
  .address-cards {
    grid-template-columns: 1fr;
  }

  .detail-section--full {
    grid-column: auto;
  }

  .order-summary__item:not(:last-child) {
    border-right: none;
    border-bottom: 1px solid #f0f2f5;
    padding-bottom: 8px;
  }
}
</style>
